import StoreLocation from './StoreLocation';

export default StoreLocation;
